'use client';

import { Button } from '@bells/ui/components/button';
import { IconArrowRight, IconConfetti, IconX } from '@tabler/icons-react';
import { useState } from 'react';

import {
  ADVERT_COOKIE_EXPIRES_DAYS,
  ADVERT_COOKIE_NAME,
  ADVERT_COOKIE_VALUE,
} from '@/components/layouts/alert-utils';
import {
  advertBecomeAnEscortCta,
  advertBecomeAnEscortDescription,
  advertBecomeAnEscortTitle,
} from '@bells/i18n';
import { Locale } from '@bells/i18n/runtime';
import Cookies from 'js-cookie';
import { useAuth } from '@bells/core/auth';

export default function EscortAlert({
  visible,
}: {
  locale: Locale;
  visible?: boolean;
}) {
  const { isAuthed } = useAuth();
  const [isVisible, setIsVisible] = useState(visible ?? true);

  const handleAccept = (withLink: boolean) => {
    Cookies.set(ADVERT_COOKIE_NAME, ADVERT_COOKIE_VALUE, {
      expires: ADVERT_COOKIE_EXPIRES_DAYS,
    });
    setIsVisible(false);

    if (withLink) {
      window.open(`https://form.typeform.com/to/VlCtuaim`, '_blank');
    }
  };

  if (isAuthed) {
    return null;
  }

  if (!isVisible) {
    return null;
  }

  return (
    <div
      style={{
        background:
          'linear-gradient(92deg, rgb(219 26 100), rgb(187 141 255) 46%, rgb(101 82 253)) 0px 0px no-repeat padding-box padding-box transparent',
      }}
      className='dark top-0 z-10 flex items-center justify-between text-white transition-all duration-300 ease-in-out'
    >
      <div className='mx-auto my-0 flex w-full max-w-screen-xl items-center justify-between gap-4 overflow-hidden px-4 py-2 text-sm lg:px-8'>
        <div className='flex flex-1 items-center justify-center gap-2'>
          <IconConfetti className='mr-2 hidden h-5 w-5 lg:block'></IconConfetti>
          <div className='inline-block'>
            <span className='inline-block font-medium'>
              {advertBecomeAnEscortTitle()}
            </span>
            {` `}
            <span
              onClick={() => handleAccept(true)}
              className='inline-block cursor-pointer underline hover:font-medium'
            >
              {advertBecomeAnEscortDescription()}
            </span>
          </div>
          <IconArrowRight className='hidden lg:inline-block'></IconArrowRight>
          <Button
            onClick={() => handleAccept(true)}
            className='hidden lg:inline-flex'
            size={'xs'}
          >
            {advertBecomeAnEscortCta()}
          </Button>
        </div>
        <Button
          onClick={() => handleAccept(false)}
          size={'iconMedium'}
          variant={'ghost'}
        >
          <IconX></IconX>
        </Button>
      </div>
    </div>
  );
}
